import { Document, LocalFile } from '@graphql/generated';

export const getDocumentIds = (documents: { id: string }[]): string[] => {
  return documents.map((item) => {
    if (item.id.includes('-')) {
      return item.id.split('-')[1];
    } else {
      return item.id;
    }
  });
};

/**
 * Filters a mixed selection down to persisted Document items only.
 * getDocumentIds() splits ids on '-' to unwrap composite ids; LocalFile.id is
 * a UUID clientId (multiple dashes) and would be truncated to garbage if
 * passed through, so exclude anything that isn't a persisted Document before
 * building share/document ids from a selection that may include in-progress
 * local uploads. — TA-10212
 */
export const filterShareableDocuments = (
  items: Array<Document | LocalFile>
): Document[] =>
  items.filter((item): item is Document => item.__typename === 'Document');

/**
 * Only images and videos are supported by the public /images-preview/ page —
 * everything else must fall back to the general createShareLink flow. Derive
 * this from the current selection rather than tracking it as separate state:
 * a stateful isMedia flag in native ProjectFiles.tsx went stale on tab
 * re-entry (QA TA-10212 follow-up), silently routing media shares into the
 * wrong branch. — TA-10212
 */
export const isMediaSelection = (
  documents: Array<{ isImage?: boolean; isVideo?: boolean }>
): boolean =>
  // Array.every is vacuously true on an empty array — an empty selection is
  // not "media", it's nothing, so require at least one document explicitly.
  documents.length > 0 && documents.every((doc) => doc.isImage || doc.isVideo);
